if (!customElements.get('quote-modal')) {
  customElements.define(
    'quote-modal',
    class QuoteModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuoteInfo-"]');
        this.iframe = null;
        this.titleElement = null;
        this.subtitleElement = null;
        
        // Get attributes
        this.variantId = this.getAttribute('variant-id');
        this.title = this.getAttribute('title') || 'Product';
        this.type = this.getAttribute('type') || 'quote';
        this.labelTitle = this.getAttribute('label-title') || '';
      }

      show(opener) {
        // Create modal content if it doesn't exist
        if (!this.modalContent) {
          this.createModalContent();
        }

        // Update iframe source and title based on type
        this.updateContent();

        // Push GA4 event to dataLayer
        if (window.dataLayer) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'request_quote',
            ecommerce: {
              items: [{
                item_id: this.variantId,
                item_name: this.title,
                quote_type: this.type,
                sku: this.sku
              }]
            }
          });
        }

        // Show the modal
        super.show(opener);
      }

      createModalContent() {
        // Create the modal content structure
        const contentHTML = `
          <div role="dialog" 
               aria-label="${this.labelTitle}" 
               aria-modal="true" 
               class="quote-modal__content popup-modal__content custom-scrollbar" 
               tabindex="-1">
            <button id="ModalClose-${this.variantId || 'default'}" 
                    type="button" 
                    class="quick-add-modal__toggle tap-target button-control" 
                    aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            
            <div class="quote-modal__header">
              <h2 class="section-title h4" id="QuoteModalTitle-${this.variantId || 'default'}">${this.labelTitle}</h2>
              <p class="quote-modal__subtitle">${this.title}</p>
            </div>
            
            <div class="quote-modal__body">
              <iframe class="quote-iframe" 
                      id="QuoteIframe-${this.variantId || 'default'}"
                      width="100%" 
                      height="500px" 
                      type="text/html" 
                      frameborder="0" 
                      allowtransparency="true" 
                      style="border: 0">
              </iframe>
            </div>
          </div>
        `;

        this.innerHTML = contentHTML;
        this.modalContent = this.querySelector('[id^="QuoteInfo-"]');
        this.iframe = this.querySelector('.quote-iframe');
        this.titleElement = this.querySelector('[id^="QuoteModalTitle-"]');
        this.subtitleElement = this.querySelector('.quote-modal__subtitle');
      }

      updateContent() {
        if (!this.iframe) return;

        const variantId = this.variantId;
        if (!variantId) {
          console.error('QuoteModal: No variant ID or product ID provided');
          return;
        }

        // Update iframe source based on type
        if (this.type === 'tradein') {
          this.iframe.src = `https://info.wpiinc.com/l/993012/2024-06-28/466db1?Product=${variantId}`;
          if (this.titleElement) {
            this.titleElement.textContent = this.labelTitle || 'Trade-in Available';
          }
        } else {
          this.iframe.src = `https://info.wpiinc.com/get-quote-popup?Product=${variantId}`;
          if (this.titleElement) {
            this.titleElement.textContent = this.labelTitle || 'Request a Quote';
          }
        }

        // Update subtitle
        if (this.subtitleElement) {
          this.subtitleElement.textContent = this.title;
        }
      }

      // Override hide to clean up iframe
      hide(preventFocus = false) {
        if (this.iframe) {
          this.iframe.src = 'about:blank';
        }
        super.hide(preventFocus);
      }

      // Method to update variant ID dynamically
      updateVariantId(variantId) {
        this.variantId = variantId;
        this.setAttribute('variant-id', variantId);
        this.updateContent();
      }

      // Method to update product title dynamically
      updateTitle(title) {
        this.title = title;
        this.setAttribute('title', title);
        if (this.subtitleElement) {
          this.subtitleElement.textContent = title;
        }
      }

      // Method to change modal type
      setType(type) {
        this.type = type;
        this.setAttribute('type', type);
        this.updateContent();
      }
    }
  );
}

// Listen for variant changes to update quote button
document.addEventListener('variant:change', function(event) {
  const quoteButtons = document.querySelectorAll('[data-quote-button]');
  if (quoteButtons.length && event.detail && event.detail.variant) {
    quoteButtons.forEach(button => {
      button.setAttribute('data-variant-id', event.detail.variant.id);
    });
  }
});
